import React from 'react';
import queryString from 'query-string';
import { Form, Progress } from 'reactstrap';
import { CSSTransition } from 'react-transition-group';

import { WithLocalize } from "../../containers/I18nProvider";
import { WithCaptcha } from '../../containers/captcha';

/**
 * Login Form Container
 *
 * @class LoginForm
 * @extends {React.Component}
 */
class LoginForm extends React.Component {

  constructor(props, context) {
    super(props, context);

    this.parameters = queryString.parse(props.location.search);
    this.parameters.idp = 'clig';
    this.ref = React.createRef();
    this.state = {
      onLogin: false,
      showForm: false,
      error: {
        open: false,
        message: ''
      },
      username: '',
      password: ''
    };
  }

  componentDidMount() {

    this.setState({ showForm: true });
  }

  onError(error) {
    this.setState({
      error: {
        open: true,
        message: error.message
      }
    });
  }

  async onSubmit(ev) {
    ev.preventDefault();

    this.setState({
      onLogin: true,
      error: {
        open: false,
        message: ''
      }
    });



    this.props.api.userPassLogin(
      {
        username: this.usernameInput.value,
        password: this.passwordInput.value
      }, this.parameters
    )
      .then((response) => {
        this.setState({ onLogin: false });
        window.location = this.parameters.redirect_uri + '?' + queryString.stringify(response);
      })
      .catch(error => {
        const translate = this.props.translate(error.errorCode);

        let message = 'Usuário não encontrado! ';

        if (translate) {
          message = translate;
        } else if (error.details) {
          message = error.details;
        }

        this.setState({ onLogin: false, error: { open: true, message: message } });
      });
  }

  render() {
    const { translate } = this.props;

    return (
      <CSSTransition
        in={this.state.showForm}
        timeout={300}
        classNames="formshow"
        nodeRef={this.ref}
        unmountOnExit
      >
        <div ref={this.ref}>
          <Form onSubmit={event => this.onSubmit(event)}>
            <input
              className='form-control input-clig input-clig-1'
              disabled={this.state.onLogin}
              ref={(ref) => {
                this.usernameInput = ref;
              }
              }
              required={true}
              tabIndex={1}
              type="text"
              autoCorrect="off"
              autoCapitalize="none"
              name="username"
              placeholder="CPF ou CNPJ"
            />
            <input
              className='form-control input-clig input-clig-2'
              required={true}
              disabled={this.state.onLogin}
              ref={(ref) => {
                this.passwordInput = ref;
              }
              }
              tabIndex={1}
              type="password"
              autoCorrect="off"
              autoCapitalize="none"
              name="password"
              placeholder="Senha"
            />
            {!this.state.onLogin ?
              <button
                className='btn btn-lg btn-primary btn-block btn-clig'
                block={!this.parameters.failureRedirect}
                tabIndex={1}
                type="submit"
                name="submit"
                disabled={!this.props.turnstileSuccess}
              >
                {translate('ButtonEnter')}
              </button> :
              <Progress animated color="danger" value={100} className='clig-progress' />}
            <div className='clig-error-container'>
              <strong className='clig-error-msg'>{this.state.error.message} </strong>
            </div>
          </Form>
        </div>

      </CSSTransition>
    );
  }
}

export default WithCaptcha(WithLocalize(LoginForm), { style: { marginTop: '2rem' } });
